module.exports = __webpack_public_path__ + "img/bitbucket.9c517cee.svg";